import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AvatarComponent} from '../../shared/avatar/avatar.component';
import {NgClass, NgIf} from '@angular/common';
import {Tooltip} from 'primeng/tooltip';
import {DialogModule} from 'primeng/dialog';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {Button} from 'primeng/button';
import {InputText} from 'primeng/inputtext';
import {Menu} from 'primeng/menu';
import {MenuItem} from 'primeng/api';

@Component({
  selector: 'app-common-header',
  standalone: true,
  imports: [
    NgClass,
    Tooltip,
    DialogModule,
    NgIf,
    Button,
    InputText,
    Menu,
  ],
  templateUrl: './common-header.component.html',
  styleUrl: './common-header.component.scss'
})
export class CommonHeaderComponent {
  @Input() data: Record<string, any> | null = null;
  @Input() firstName: string = 'firstName';
  @Input() lastName: string = 'lastName';
  @Input() title: string = 'title';
  @Input() id: string = 'consultantId';
  @Input() isFavIconVisible!: boolean;
  @Input() isFavorite!: boolean;
  @Input() isResumeVisible: boolean = false;
  @Input() resumeUrl: string = '';
  @Input() isVideoVisible: boolean = false;
  @Input() videoUrl: string = '';
  @Input() isShareButtonVisible: boolean = false;
  shareDialogVisible = false;
  @Output() onFavClick = new EventEmitter();
  @Output() downloadPdf = new EventEmitter();
  videoModalVisible = false;
  @Input() slug!: string;
  copyButtonLabel: string = 'Copy';
  @Input() solutionAttachments: any[] =[];
  @Input() menuItems!: MenuItem[];

  constructor(private sanitizer: DomSanitizer) {
  }

  toggleFavorite() {
    this.isFavorite = !this.isFavorite;
    this.onFavClick.emit(this.isFavorite);
  }

  openVideoModal() {
    this.videoModalVisible = true;
  }

  private extractGoogleDriveFileId(url: string): string {
    const match = url.match(/\/file\/d\/([^\/]+)/) ||
      url.match(/id=([^&]+)/) ||
      url.match(/\/([^\/]{33})[^\/]*$/);
    return match ? match[1] : url;
  }

  isGoogleDriveUrl(url: string): boolean {
    return url.includes('drive.google.com');
  }

  getSafeEmbedUrl(url: string): SafeUrl {
    const fileId = this.extractGoogleDriveFileId(url);
    const embedUrl = `https://drive.google.com/file/d/${fileId}/preview`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
  }

  get shareUrl(): string {
    return window.location.origin + `/consultant-detail/${this.slug ? this.slug : this.id}`;
  }

  copyLinkToClipboard() {
    navigator.clipboard.writeText(this.shareUrl || '').then(() => {
      this.copyButtonLabel = 'Copied!';

      setTimeout(() => {
        this.copyButtonLabel = 'Copy';
      }, 1000);
    });
  }

  openWhatsApp() {
    const url = 'https://wa.me/?text=' + encodeURIComponent(this.shareUrl);
    window.open(url, '_blank');
  }

  downloadAsPdf() {
    this.shareDialogVisible = false;
    this.downloadPdf.emit(true);
  }

}
